import { ReverbUITheme, ThemeProvider } from '@reverb-ui/react';
import React from 'react';
import ReactDOM from 'react-dom';
import { Userpilot } from 'userpilot';

import AuthProvider, {GlobalAuthContext, } from './contexts/auth';
import reportWebVitals from './reportWebVitals';
import AppRouter from './router/AppRouter';
import { Router } from './router/Router';

ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider theme={ReverbUITheme} resetCSS>
      <AuthProvider>
        < GlobalAuthContext.Consumer >    
        {({ loading } ) => (
          <>
            {!loading && (
              <Router>
                <AppRouter />
              </Router>
            )}
          </>
        )}
        </GlobalAuthContext.Consumer>
      </AuthProvider>
    </ThemeProvider>
  </React.StrictMode>,
  document.querySelector('#root'),
);

reportWebVitals(() => null);

// Initialize Userpilot
Userpilot.initialize(process.env.REACT_APP_USERPILOT_KEY || '');